module.exports = __webpack_public_path__ + "static/media/lock.46e2638b.svg";